import { render, staticRenderFns } from "./PreferredVendors.vue?vue&type=template&id=7a08d74c&scoped=true&"
import script from "./PreferredVendors.vue?vue&type=script&lang=js&"
export * from "./PreferredVendors.vue?vue&type=script&lang=js&"
import style0 from "./PreferredVendors.vue?vue&type=style&index=0&id=7a08d74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08d74c",
  null
  
)

/* custom blocks */
import block0 from "./PreferredVendors.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports